import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  customStyle,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import Select from "react-select";
import moment from 'moment';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";


const StockConsumptionReport = () => {
    const { t } = useTranslation();
    const history = useHistory();
    //getting context values here
    let { loading, setLoading, dataPaginating, generalSettings } =
      useContext(SettingsContext);
    let { branchForSearch,ingredientItemForSearch, ingredientGroupForSearch, getIngredientGroup } = useContext(RestaurantContext);
    const { authUserInfo } = useContext(UserContext);
  
    let [newStockConsumptionReport, setNewStockConsumptionReport] = useState({
      branch:null,
      item:null,
      group: null
    });
    
    //all data
    const [reportData, setReportData] = useState(null);
    const [reportSummaryData, setReportSummaryData] = useState(null);
  
    const componentRef = useRef();
    const componentRef1 = useRef();
    //settle order
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [generatedReport, setGeneratedReport] = useState(false);
    const [option, setOption] = useState("detail_report");
    const [siteName, setSiteName] = useState("");
    //useEffect == componentDidMount()
    const [branchSearch, setBranchSearch] = useState(null);
  
    useEffect(() => {
      if(!generalSettings){
        return;
      }
      setSiteName(getSystemSettings(generalSettings, "siteName"));
      if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
        setBranchSearch(
          branchForSearch.filter(
            (branch) => branch.id === authUserInfo.details.branch_id
          )
        );
      } else {
        setBranchSearch(branchForSearch);
      }
      if(!ingredientGroupForSearch){
        getIngredientGroup();
      }
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, [generalSettings]);

    const handleBranch = (branch) => {
      setNewStockConsumptionReport({
        ...newStockConsumptionReport,
        branch:branch,
      });
      // setBranch(branch);
    };

    const handleOption  = (e) =>{
      setOption(e.target.value)
    }

    const handleGroup = (group)=>{
      setNewStockConsumptionReport({
        ...newStockConsumptionReport,
        group:group,
      });
    }

    const handleItem = (item) => {
      setNewStockConsumptionReport({
        ...newStockConsumptionReport,
        item:item,
      });
      // setBranch(branch);
    };
  
    //get BranchWise reports filter
    const handleBranchWiseReport = () => {
      if (
        (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
        !newStockConsumptionReport?.branch?.[0]?.id
      ) {
        toast.error(`${_t(t("Please select Branch to generate report"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      setReportSummaryData(null);
      setReportData(null);
      if (startDate !== null && endDate !== null) {
        setLoading(true);
      
        let startdate = moment(startDate).format("YYYY-MM-DD");
        let enddate =  moment(endDate).format("YYYY-MM-DD");

        let url = BASE_URL + "/settings/get-consumption-report";
        if(option === "summary_report"){
          url = BASE_URL + "/settings/get-consumption-summary-report";
        }
        const branch = newStockConsumptionReport?.branch?.length ? JSON.stringify(newStockConsumptionReport?.branch.map((item)=>item.id)) : "";
        const group = newStockConsumptionReport?.group?.length ? JSON.stringify(newStockConsumptionReport?.group.map((item)=>item.id)) : "";
        const item = newStockConsumptionReport?.item?.length ? JSON.stringify(newStockConsumptionReport?.item.map((item)=>item.id)) : "";

        let formData = new FormData();
        formData.append("from_date", startdate);
        formData.append("to_date", enddate);
        formData.append("branch_id", branch);
        formData.append("ingredient_group_id", group);
        formData.append("item_id", item);

        return axios
          .post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setLoading(false);
            setGeneratedReport(true);
            if(option === "summary_report"){
              setReportSummaryData(res.data[0]);
              componentRef1.current.handleDownload();
            }else{
              setReportData(res.data[0]);
              componentRef.current.handleDownload();
            }
            setNewStockConsumptionReport({
              branch:null,
              item:null,
              group:null
            });
          })
          .catch((error) => {
            setNewStockConsumptionReport({
              branch: null,
              item: null,
              group: null
            });
            setLoading(false);
          });
      } else {
        toast.error(
          `${_t(t("Please select from date, branch"))}`,
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      }
    };

  return (
    <>
    <Helmet>
      <title>{_t(t("Stock Consumption Report"))}</title>
    </Helmet>
    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls"
      filename="Stock Consumption Report"
      sheet="sheet 1"
      buttonText="Sales Detail"
      ref={componentRef}
    />

    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls-summary"
      filename="Stock Consumption Summary Report"
      sheet="sheet 1"
      buttonText="Sales Detail"
      ref={componentRef1}
    />

    {/* Print Button */}
    <div className="d-none">
      <div>
        <style type="text/css" media="print">
          {
            "\
        @page { size: landscape; }\
      "
          }
        </style>
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="9" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Stock Consumption Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {startDate}
                                        </Moment> {" "}
                                        To&nbsp;
                                        <Moment format="LL">
                                          {endDate}
                                        </Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                >
                                {_t(t("Group Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                {_t(t("Item Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Date"))}
                                </th>
                                
                                <th
                                  scope="col"
                                >
                                  {_t(t("Branch Name"))}
                                </th>
                                {/*<th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Item Name"))}
                                </th>*/}
                                <th
                                  scope="col"
                                >
                                  {_t(t("Unit"))}
                                </th>

                                <th
                                  scope="col"
                                >
                                  {_t(t("Stock Qty"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Avg Rate"))}
                                </th>
                               
                                <th
                                  scope="col"
                                >
                                  {_t(t("Amount"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {console.log("309 ", reportData)}
                              {/* loop here*/}
                              {reportData &&
                                Object.keys(reportData).map(
                                  (group_name, index) => {
                                    return(
                                    <div key={index}>
                                      <tr>
                                        <th
                                          scope="row"
                                          className="lg-text text-capitalize align-middle text-center"
                                        >
                                          {group_name}
                                        </th>
                                      </tr>
                                      {Object.keys(reportData[group_name]) && Object.keys(reportData[group_name]).map((item_name) => {
                                        let amount = 0; 
                                        let Stock_Qty = 0;
                                        return (
                                          <>
                                            <tr>
                                              <th></th>
                                              <th
                                                scope="row"
                                              >
                                                {item_name}
                                              </th>
                                            </tr>
                                            {
                                              Object.keys(reportData[group_name][item_name]) &&
                                              Object.keys(reportData[group_name][item_name])?.length && Object.keys(reportData[group_name][item_name])?.map((item_i, ind)=>{
                                                let Amount = 0; 
                                                let stock_Qty = 0;
                                                return (
                                                  <>
                                                    <tr>
                                                      <th></th>
                                                      <th></th>
                                                      <th
                                                        scope="row"
                                                      >
                                                        {item_i}
                                                      </th>
                                                    </tr>
                                                    {reportData[group_name][item_name][item_i] && reportData[group_name][item_name][item_i].map((item, i) => {
                                                      Amount += parseFloat(item.amount);
                                                      stock_Qty += parseFloat(item.stock_qty);
                                                      amount += parseFloat(item.amount); 
                                                      Stock_Qty += parseFloat(item.stock_qty);

                                                      return (
                                                        <tr>
                                                          <td></td>
                                                          <td></td>
                                                          <td></td>
                                                          <td
                                                            scope="row"
                                                          >
                                                            {i + 1}
                                                          </td>
                                                          <td
                                                            scope="row"
                                                          >
                                                            <Moment format="LL">
                                                              {item.document_date}
                                                            </Moment>
                                                          </td>
                                                          <td
                                                            scope="row"
                                                          >
                                                            {item.unit_name}
                                                          </td>
                                                          <td
                                                            scope="row"
                                                          >
                                                            {item.stock_qty}
                                                          </td>
                                                          
                                                          <td
                                                            scope="row"
                                                          >
                                                            {formatPrice(item.avg_rate)}
                                                          </td>
                                                        
                                                          <td
                                                            scope="row"
                                                          >
                                                            {formatPrice(item.amount)}
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                    <tr>
                                                      <td></td>
                                                      <td></td>
                                                      <th
                                                        scope="row"
                                                      >
                                                        Total
                                                      </th>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td
                                                      scope="row"
                                                      >
                                                        <strong>{formatPrice(stock_Qty)}</strong>
                                                      </td>
                                                      <td></td>
                                                      <td
                                                      scope="row"
                                                      >
                                                        <strong>{formatPrice(Amount)}</strong>
                                                      </td>
                                                    </tr>
                                                    {(ind !== Object.keys(reportData[group_name][item_name]).length - 1) && <tr></tr>}
                                                  </>
                                                )
                                              })
                                            }
                                            <tr>
                                              <td></td>
                                              <th
                                                scope="row"
                                              >
                                                Grand Total
                                              </th>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td
                                              scope="row"
                                              >
                                                <strong>{formatPrice(Stock_Qty)}</strong>
                                              </td>
                                              <td></td>
                                              <td
                                              scope="row"
                                              >
                                                <strong>{formatPrice(amount)}</strong>
                                              </td>
                                            </tr>
                                            <tr></tr>
                                          </>
                                        );
                                      })}
                                    </div>
                                    );
                                  }
                                )
                              }
                              {/*<tr>
                                <th className="sm-text text-capitalize align-middle text-center border-1 border"></th>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border"></td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border"></td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border"></td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border"></td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border"></td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                  Total
                                </td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                  {formatPrice(stock_inn)}
                                </td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                  {formatPrice(stock_out)}
                                </td>
                                <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                  {formatPrice(amount)}
                                </td>
                             </tr>*/}
                            </tbody>

                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="7"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">
                                    Powered by indolj.pk
                                  </h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Print summary Button */}
    <div className="d-none">
      <div>
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {reportSummaryData !== null &&
                  reportSummaryData &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls-summary"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="8" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Stock Consumption Summary Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {startDate}
                                        </Moment> {" "}
                                        To&nbsp;
                                        <Moment format="LL">
                                          {endDate}
                                        </Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                >
                                {_t(t("Group Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Branch Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                {_t(t("Item Name"))}
                                </th>
                                
                                <th
                                  scope="col"
                                >
                                  {_t(t("Unit"))}
                                </th>

                                <th
                                  scope="col"
                                >
                                  {_t(t("Stock Qty"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Avg Rate"))}
                                </th>
                               
                                <th
                                  scope="col"
                                >
                                  {_t(t("Amount"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {reportSummaryData &&
                                Object.keys(reportSummaryData).map(
                                  (group_name, index) => {
                                    let amount = 0; 
                                    let Stock_Qty = 0;
                                    return(
                                    <div key={index}>
                                      <tr>
                                        <th
                                          scope="row"
                                        >
                                          {group_name}
                                        </th>
                                      </tr>
                                      {Object.keys(reportSummaryData[group_name]) && Object.keys(reportSummaryData[group_name])?.length && Object.keys(reportSummaryData[group_name]).map((item_name, ind) => {
                                        let amount1 = 0; 
                                        let Stock_Qty1 = 0;
                                        return(
                                          <>
                                            <tr>
                                              <th></th>
                                              <th
                                                scope="row"
                                              >
                                                {group_name}
                                              </th>
                                            </tr>
                                            {reportSummaryData[group_name][item_name] && reportSummaryData[group_name][item_name]?.length && reportSummaryData[group_name][item_name].map((item, i) => {
                                              amount += parseFloat(item.base_amount); 
                                              Stock_Qty += parseFloat(item.stock_qty);
                                              amount1 += parseFloat(item.base_amount); 
                                              Stock_Qty1 += parseFloat(item.stock_qty);
                                              return (
                                                <tr key={i}>
                                                  <td></td>
                                                  <td></td>
                                                  <td
                                                    scope="row"
                                                  >
                                                    {i + 1}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                  >
                                                    {item.item_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                  >
                                                    {item.unit_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                  >
                                                    {formatPrice(Number(item.stock_qty))}
                                                  </td>
                                                  
                                                  <td
                                                    scope="row"
                                                  >
                                                    {formatPrice(Number(item.avg_rate))}
                                                  </td>
                                                
                                                  <td
                                                    scope="row"
                                                  >
                                                    {formatPrice(Number(item.base_amount))}
                                                  </td>
                                                </tr>
                                                );
                                              })
                                            }
                                            <tr>
                                              <th
                                                scope="row"
                                              >
                                                Total
                                              </th>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td
                                              scope="row"
                                              >
                                                <strong>{formatPrice(Stock_Qty1)}</strong>
                                              </td>
                                              <td></td>
                                              <td
                                              scope="row"
                                              >
                                                <strong>{formatPrice(amount1)}</strong>
                                              </td>
                                            </tr>
                                            {(ind !== Object.keys(reportSummaryData[group_name]).length - 1) && <tr></tr>}
                                          </>
                                        )
                                      })}
                                      <tr>
                                        <th
                                          scope="row"
                                        >
                                          Grand Total
                                        </th>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td
                                        scope="row"
                                        >
                                          <strong>{formatPrice(Stock_Qty)}</strong>
                                        </td>
                                        <td></td>
                                        <td
                                        scope="row"
                                        >
                                          <strong>{formatPrice(amount)}</strong>
                                        </td>
                                      </tr>
                                      <tr></tr>
                                    </div>
                                    );
                                  }
                                )
                              }
                            </tbody>

                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="7"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">
                                    Powered by indolj.pk
                                  </h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ReportSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-2 mb-lg-0">
            <div className="t-bg-white p-1">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={dataPaginating || loading}/>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {/* {loading === true ? (
                    tableLoading()
                  ) : ( */}
                   <>
                    <div key="smtp-form mt-2">
                      <div className="row mt-1 gx-2 align-items-center t-pt-2 t-pb-2">
                        <div className="col-12 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize mt-2">
                                {_t(t("Stock Consumption Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2 mt-1">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-2 mb-md-0"
                            placeholderText={_t(t("Start Date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>
                        <div className="col-2 mt-1">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-2 mb-md-0"
                            placeholderText={_t(t("End Date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>

                        <div className="col-3 mt-1">
                          <Select
                            options={branchSearch && branchSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newStockConsumptionReport?.branch ?? ""}
                            isMulti
                            classNamePrefix="select"
                            styles={customStyle}
                            className="sm-text "
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-2 mt-1">
                          <Select
                            options={ingredientGroupForSearch ? ingredientGroupForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newStockConsumptionReport?.group ?? ""}
                            isMulti
                            classNamePrefix="select"
                            className="sm-text"
                            styles={customStyle}
                            onChange={handleGroup}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>

                        <div className="col-3 mt-1">
                          <Select
                            options={ingredientItemForSearch && ingredientItemForSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newStockConsumptionReport?.item ?? ""}
                            isMulti
                            classNamePrefix="select"
                            className="sm-text"
                            styles={customStyle}
                            onChange={handleItem}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select item")) + ".."}
                          />
                        </div>
                        <div className="col-6 mt-3"></div>
                        <div className="col-4 d-flex align-items-center justify-content-end mt-3">
                          <div className="d-flex align-items-center mr-3">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="detail_report"
                              name="detail_report"
                              value="detail_report"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "detail_report"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="detail_report"
                            >
                              {_t(t("Detail Report"))}
                            </label>
                          </div>
                          <div className="d-flex align-items-center mr-1">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="summary_report"
                              name="summary_report"
                              value="summary_report"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "summary_report"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="summary_report"
                            >
                              {_t(t("Summary Report"))}
                            </label>
                          </div>
                        </div>
                        <div className="col-2 mt-3">
                          <button
                          className="btn-primary btn-block text-uppercase sm-text py-2 rounded border-0"
                          onClick={(e) => handleBranchWiseReport(e)}
                          >
                            Consumption Report
                          </button>
                        </div>
                      </div>
                    </div>

                   </>
                  {/* )} */}
                </div>

              </div>
                
            </div>
            
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
  </>
  )
}

export default StockConsumptionReport
